import { useState } from "react";
import { MailWarning, Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";
import { toast } from "sonner";

export function VerifyBanner() {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  if (!user || user.email_verified !== false) return null;

  const resend = async () => {
    setBusy(true);
    try {
      await api("/auth/resend-verification", { method: "POST" });
      setSent(true);
      toast.success("Verification email sent. Check your inbox.");
    } catch (e) {
      toast.error(e.message || "Could not send verification email");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      data-testid="verify-email-banner"
      className="flex flex-wrap items-center gap-3 border-b border-amber-300 bg-amber-50 px-4 py-2.5 text-sm text-amber-900 sm:px-8"
    >
      <MailWarning className="h-4 w-4 shrink-0" />
      <span className="flex-1 min-w-[180px]">
        Please verify your email address to secure your account.
      </span>
      <button
        onClick={resend}
        disabled={busy || sent}
        data-testid="verify-email-resend-btn"
        className="inline-flex items-center gap-2 rounded-md bg-amber-600 px-3 py-1.5 text-xs font-bold text-white disabled:opacity-60"
      >
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : null}
        {sent ? "Email sent" : "Resend email"}
      </button>
    </div>
  );
}
